/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_2ad7e0ca"]'><div><div :style='["height: 6vh;position:relative"] | transRpxStyle' @tap='(e)=>__invoke(e, [["refresh"]])'>{{ pos }}</div><cube-sticky :pos="(pos)" ref="__mpx_ref_sticky__"><mpx-scroll-view :scroll-y="(true)" :style='["height: 94vh;position:relative"] | transRpxStyle' @scroll='(e)=>__invoke(e, [["onScroll"]])'><div :class='["sticky-content"]'><div v-for="(item, index) in (dataArr)" :key="item" :class='["content-item"]'>内容1项 {{item}}</div></div><cube-sticky-ele eleKey="2"><div :class='["sticky-header"]'>吸顶标题 2</div></cube-sticky-ele><div :class='["sticky-content"]'><div v-for="(item, index) in ([1,2,3,4,5])" :key="item" :class='["content-item"]'>内容2项 {{item}}</div></div><cube-sticky-ele eleKey="3"><div :class='["sticky-header"]'>吸顶标题 3</div></cube-sticky-ele><div :class='["sticky-content"]'><div v-for="(item, index) in ([1,2,3,4,5,6,7,8,9,10])" :key="item" :class='["content-item"]'>内容项 {{item}}</div></div></mpx-scroll-view></cube-sticky></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_2ad7e0ca"}'>
.sticky-header
  height: 50px
  line-height: 50px
  padding: 0 15px
  background-color: #fc9153
  color: #fff
  font-size: 16px
  font-weight: bold

.sticky-content
  padding: 15px
  background-color: #f5f5f5

.content-item
  height: 120px
  line-height: 40px
  margin-bottom: 10px
  padding: 0 15px
  background-color: #fff
  border-radius: 4px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_2ad7e0ca"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_2ad7e0ca"}
  /** script content **/
  require("./sticky-basic.mpx.js?isComponent&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./sticky-basic.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fsticky-basic2ad7e0ca%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_2ad7e0ca"],
    ctorType: "component",
    outputPath: "components/sticky-basic2ad7e0ca/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-sticky':getComponent(require("../../../packages/mpx-cube-ui/src/components/sticky/index.mpx?isComponent&outputPath=components%2Findex580e16a0%2Findex")),'cube-sticky-ele':getComponent(require("../../../packages/mpx-cube-ui/src/components/sticky/sticky-ele/index.mpx?isComponent&outputPath=components%2Findex639a4e0d%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>